import { twMerge } from 'tailwind-merge'

type Props = {
  children: React.ReactNode
} & ((React.ComponentPropsWithoutRef<'div'>))

export function Box({ className, children }: Props) {
  className = twMerge(
    'w-full p-0 sm:p-8 sm:border rounded-md ',
    'flex justify-center',
    className,
  )

  return (
    <div className={className}>
      {children}
    </div>
  )
}
